import React from 'react';
import { FinancialYearYearlyTimeSelectionInput } from '../../../../api/types-graphql';
import {
  DashboardConfig,
  LanguageString,
} from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { HcSimulationPage } from '../../../../pages/dashboards/HCSimulationDashboard/HcSimulationPage';
import {
  DataFieldWithDataType,
  DataTypes,
  EmployeeDataFields,
  TimeSelectionType,
} from '../../../../types';

const dashboardId = 'hc-simulation';

const nssolSegmentFields: DataFieldWithDataType[] = [
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.AGE_GROUP,
  },
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.ORGANIZATION,
  },
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.CUSTOM_FILTER_2,
  },
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.CUSTOM_FIELD_6,
  },
];

// NSSOL's simulation data is keyed by financial year, so the chart must bucket
// by FY - bucketing by calendar year leaves the latest years (e.g. 2026) empty.
const nssolSimulationYearRange: FinancialYearYearlyTimeSelectionInput = {
  start: 2026,
  end: 2035,
};

// The simulation model emits one value per financial year, effective at the
// START of that year (NSSOL FY2026 = 2026-04 to 2027-03, so the FY2026 point is
// April 2026). PBS and the backend metric definition report a financial year as
// of its END, so until the model output is moved to the last month of the FY the
// chart is showing beginning-of-year figures. Disclose that in the footer.
const nssolSimulationFooter: LanguageString = {
  [Languages.EN]:
    '※ Figures show projected headcount as of the start of each financial year (April), not the financial year end.',
  [Languages.JA]:
    '※ 各会計年度の期首（4月）時点の予測人員数を表示しています。期末時点の数値ではありません。',
};

const NssolHcSimulationPage = () => (
  <HcSimulationPage
    segmentFields={nssolSegmentFields}
    simulationYearRange={nssolSimulationYearRange}
    simulationTimeSelectionType={TimeSelectionType.FinancialYearYearly}
    footer={nssolSimulationFooter}
  />
);

export const NssolHcSimulationDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'HC Simulation Dashboard',
    [Languages.JA]: '要員計画シミュレーション結果',
  },
  enabled: true,
  pages: [
    {
      pageId: '1',
      dashboardId,
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'HC Simulation Page 1',
        [Languages.JA]: '要員計画シミュレーション結果',
      },
      pageOptions: {
        dataView: {
          enabled: false,
        },
        filterTray: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: false,
        },
      },
      gridRows: 1,
      gridCols: 1,
      configType: 'pageComponent',
      pageComponent: NssolHcSimulationPage,
      link: '/dashboard/headcount-simulation/2',
    },
  ],
};
